import React from 'react';

import Row from './row';
import TotalRow from './total-row';
import './main.less';

const Table = props => {
	const { table, intl, dates }  = props;

	return (
		<div className="table-container guarant-approve-forecast-table">
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium sticky-top-0">
					<tr>
						{
							table.headers
								.map((header, i) =>
									<th key={i} className={header.className}>
										<span>{intl(header.title)}</span>
									</th>
								)
						}
						<th className="border-col" />
						{
							dates.map((date, i) =>
								<th key={i} className="date-col">
									<p className="border-bottom flex-center">{intl(date)}</p>
									<p>
										<span className="sub-col"> Leads </span>
										<span className="sub-col"> % CPA </span>
										<span className="sub-col"> Diff % </span>
										<span className="sub-col"> Summ $ </span>
									</p>
								</th>
							)
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{table.rows.map((row, i) =>
						<Row key={i} row={row} {...props} index={i} />
					)}
					<TotalRow {...props} rows={table.rows} />
				</tbody>
			</table>
		</div>
	);
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/garant-forecast/components/table/main.js